document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-grid-slider').forEach(function (slider) {
        const $slider = $(slider);

        // Check if there's only one slide
        const totalSlides = $slider.children().length;

        $slider.slick({
            dots: true,
            arrows: false,
            lazyLoad: 'progressive',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            adaptiveHeight: true // Ensures proper height adjustment for single slide
        });

        // Manually add the dots inside the slider if there's only one slide
        if (totalSlides === 1) {
            // Create the dots container
            const dotsMarkup = `
                <ul class="slick-dots">
                    <li class="slick-active"><button type="button">1</button></li>
                </ul>
            `;

            // Append the dots inside the slider container
            $slider.append(dotsMarkup);
        }
    });
});
